import { alpha } from "@mui/material/styles";
import { getLinkToken } from "../fundations/palette/colorTokens";
export const Link = {
    MuiLink: {
        styleOverrides: {
            root: ({ theme })=>({
                    color: getLinkToken("linkSecondary", theme),
                    textDecorationColor: alpha(getLinkToken("linkSecondary", theme), 0.24),
                    fontWeight: theme.typography.fontWeightMedium,
                    textUnderlineOffset: 5,
                    "&:hover": {
                        cursor: "pointer"
                    }
                })
        },
        variants: [
            {
                props: {
                    color: "primary"
                },
                style: ({ theme })=>({
                        color: getLinkToken("linkPrimary", theme),
                        textDecorationColor: alpha(getLinkToken("linkPrimary", theme), 0.24)
                    })
            }
        ]
    }
};

//# sourceMappingURL=Link.js.map